import React, { Component } from 'react';
import {imageUrl} from 'helpers/ApplicationHelper';
import YouTube  from 'react-youtube';
import {isMobile, isIos, isIpad} from 'helpers/ApplicationHelper';
import PopupVideo from 'components/popups/popupVideo';
import _ from 'underscore'

class RichMultipleButtons extends Component {
    constructor(props) {
        super(props);

        this.state = {
            buttons: _.map(this.props.message.buttons, (button)=>{return button;}),
            stickyButtons: _.map(this.props.message.stickyButtons, (button)=>{return button;}),
            selectedButton: "0"
        };

        this.renderButton = this.renderButton.bind(this);
        // this.renderOptions = this.renderOptions.bind(this);
        // this.selectOption = this.selectOption.bind(this);
    }

    componentWillReceiveProps({message}) {
        if(message){
            this.setState({
                buttons: _.map(message.buttons, (button)=>{return button;}),
                stickyButtons: _.map(message.stickyButtons, (button)=>{return button;})
            });
        }
    }

    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();

    }

    videoClicked(button) {
        if(isMobile() && isIos()) {
            let elem = document.getElementById(button.label);
            elem.className = '';
        }
        else {
            PopupVideo.initPopup({button: button});
        }
    }

    renderButton(button, i){
        let isVideoButton = button.videoButton === 'true';
        let className = isVideoButton ? "video-button" : "button";
        let opts = {
            height: '122',
            width: '171',
            playerVars: {
                autoplay: 1
            }
        };
        return(
            //{<div key={i} className={className} onClick={()=>{this.props.onClick(this.props.message, button)}}>}
            <div key={i} className={className}>
                {isVideoButton ?
                    <div>
                        <span className="title"><strong>{button.titleBold}</strong> {button.title}</span>
                        <div className="video-wrapper" onClick={(event) => {this.videoClicked(button)}}>
                            <img className="video-cover-img" src={imageUrl(button.imgSrc)}/>
                            {isMobile() && isIos() ? <YouTube
                                videoId={button.videoId}
                                id={button.label}
                                className="hidden"
                                opts={opts}
                                onReady={this._onReady}
                            /> : <div></div>}
                        </div>
                    </div> :
                    <div>Text Button</div>}
            </div>
        )
    }

    // renderOptions(button, i){
    //     return(
    //         <option key={i+1} value={i+1} dangerouslySetInnerHTML={{__html: button.text}} />
    //     )
    // }
    //
    // selectOption(i){
    //     this.setState({selectedButton: i});
    //     this.props.onClick(this.props.message, this.state.buttons.concat(this.state.stickyButtons)[i - 1]);
    // }

    render(){
        return (
            <div id={this.props.id} className="rich-message-input-container rich-message-multiple-buttons input-root">
                <div className="rich-buttons-wrapper">
                    <div className="rich-buttons-container-mobile">
                        {this.state.buttons.map(this.renderButton)}
                        {this.state.stickyButtons.map(this.renderButton)}
                    </div>
                    {/*<div className="buttons-container-desktop">*/}
                        {/*<select id={`select_${this.props.message}`} name="state" value={this.state.selectedButton} onChange={(event) => this.selectOption(event.target.value)}>*/}
                            {/*<option key="0" value="0" disabled>{this.props.message.placeholder}</option>*/}
                            {/*{this.state.buttons.concat(this.state.stickyButtons).map(this.renderOptions)}*/}
                        {/*</select>*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    }
}

export default RichMultipleButtons;